import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

export function Input(props) {
  const className = `ps_input ${props.className}`;

  const [value, setValue] = React.useState();

  React.useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  const [width, setWidth] = React.useState();

  React.useEffect(() => {
    const newWidth = props.value.toString().length * props.charWidth + 'px';
    setWidth(newWidth);
  }, [props.value]);

  const onChange = (event) => {
    !isNaN(event.target.value) && setValue(event.target.value);
  };

  const onBlur = (event) => {
    props.setValue(parseFloat(value));
  };

  const adjustInputWidth = (event) => {
    const value =
      ((event.target.value.length + 1) * props.charWidth).toString() + 'px';
    event.target.style.width = value;
  };

  const onKeyPress = (event) => {
    adjustInputWidth(event);
  };

  return (
    <input
      id={props.id}
      className={className}
      tabIndex={props.tabIndex}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      onKeyPress={onKeyPress}
      style={{width: width}}
      aria-label={props.ariaLabel}
    />
  );
}

Input.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   *  specifies if keyboard accessible or not
   */
  tabIndex: PropTypes.number,
  /**
   * value displayed on input
   */
  value: PropTypes.number,
  /**
   * callback to set value of input text (here used only when loosing focus on input)
   */
  setValue: PropTypes.func,
};

Input.defaultProps = {
  className: '',
  value: 0,
  tabIndex: 0,
};
